import { SkeletonLoader } from "../../../../../components";

export const GatewayBeneficiarySkeleton = () => (
  <div className="cds--structured-list-row cds--structured-list-row--header-row">
    <div className="cds--structured-list-td">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-teal">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      <SkeletonLoader type="text" />
    </div>

    <div className="cds--structured-list-td font-ctm--semibold ">
      <SkeletonLoader type="text" />
    </div>

    <div
      className="cds--structured-list-td"
      title="Select this beneficiary as recipient"
    >
      <SkeletonLoader type="text" />
    </div>
  </div>
);
